import { typhoonDataSource, typhoonApi } from '../../../public/config/global-config'
export default {
  namespaced: true,
  state: {
    satelliteImg: [],
    relationList: [],
    waveTempDataList: null,
    yesterdayWaveTempDataList: null,
    waveWarningData: {
      color: '#707070',
      imgName: '无',
      title: '当前无警报'
    },
    stormWarningData: {
      color: '#707070',
      imgName: '无',
      title: '当前无警报'
    },
    activeRouteId: 'g1',
    nowIsHaveTyphoon: false,
    tideStandardData: []
  },
  mutations: {
    SET_NOWISHAVETYPHOON(state, payload) {
      state.nowIsHaveTyphoon = payload
    },
    SET_STATELLITE_IMG(state, payload) {
      state.satelliteImg = payload
    },
    SET_RELATION_LIST(state, payload) {
      state.relationList = payload
    },
    SET_FORECAST_DATA(state, payload) {
      state.waveTempDataList = payload
    },
    SET_YESTERDAY_FORECAST_DATA(state, payload) {
      state.yesterdayWaveTempDataList = payload
    },
    SET_WAVE_WARNING_DATA(state, payload) {
      state.waveWarningData = payload
    },
    SET_STORM_WARNING_DATA(state, payload) {
      state.stormWarningData = payload
    },
    updateActiveRouteId(state, payload) {
      state.activeRouteId = payload
    },
    updateTideStandardData(state, payload) {
      state.tideStandardData = payload
    }
  },
  actions: {
    getNowIsHaveTyphoonAction(context, payload) {
      $http({
        url: `${typhoonDataSource}${typhoonApi}/static/current.json`,
        method: 'get'
      }).then(async res => {
        context.commit('SET_NOWISHAVETYPHOON', (res?.data?.data?.length || 0) > 0)
      })
    },
    async getSatelliteImgAction(context, payload) {
      const cloudImages = await $http.GetCloudImages()
      // console.log(cloudImages.data)
      context.commit('SET_STATELLITE_IMG', cloudImages.data.data)
    },
    // 获取类型数据对应关系
    async getWebsiteRelationAction(context, payload) {
      if (context.state.relationList.length) return
      const result = await $http.WebsiteRelation()

      const relationList = result.data.data
      context.commit('SET_RELATION_LIST', relationList)
    },
    // 获取类型数据对应关系
    async getWebsiteForecastAction(context, payload) {
      if (context.state.waveTempDataList) return
      const result = await $http.WebsiteForecast()

      const waveTempDataList = result.data.data
      context.commit('SET_FORECAST_DATA', waveTempDataList)
    },
    async getYesterdayWaveTempDataList(context, payload) {
      if (context.state.yesterdayWaveTempDataList) return
      const result = await $http.WebsiteForecastToday()
      const yesterdayWaveTempDataList = result.data.data
      context.commit('SET_YESTERDAY_FORECAST_DATA', yesterdayWaveTempDataList)
    },
    // 获取获取零点换算85高程基准
    async getWebsiteStandard(context, payload) {
      const { data: res } = await $http.WebsiteStandard()
      context.commit('updateTideStandardData', res)
    }
  },
  modules: {}
}
